import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text" }

import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardMissingFilter',
  setup(__props) {

const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)('dashboard__text-no-selection')), 1)
  ]))
}
}

})